<template>
  <vs-popup class="create-formula-popup"
            id="popup"
            title="CREATE FORMULATION"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateFormulation)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Product Name</small>
                <vs-input v-model="createStaffForm.name"   name="name" class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="createStaffForm.description" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="customer_project_brief_id" name="customer_project_brief_id" rules="" v-slot="{ errors }">
                <small class="label">Project brief</small>
                <v-select  :clearable="false" name="customer_project_brief_id" placeholder="" label="name" v-model="createStaffForm.customer_project_brief_id" :reduce="option => option.id" :options="project_briefs" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} - {{option.name}}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col  md:w-full w-full md:mb-0">
              <ValidationProvider vid="batch_weight" name="batch_weight" rules="required" v-slot="{ errors }">
                <small class="label">Batch weight (Kg)</small>
                <vs-input type="number" v-model="createStaffForm.batch_weight" class="w-full"  name="batch_weight" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="sage_nominal_code_id" name="sage_nominal_code_id" rules="required" v-slot="{ errors }">
              <small class="label">Nominal Code</small>
              <v-select :clearable="false" name="nominal_code" placeholder=""
                        label="name" v-model="createStaffForm.sage_nominal_code_id" :reduce="option => option.id"
                        :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">Formulation Type</small>
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <v-select :clearable="false" name="formulation_type" placeholder=""
                          label="name" v-model="createStaffForm.formulation_type"
                          :options="['liquid', 'powder', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const StaffRepository = RepositoryFactory.get('staff')
  const DepartmentsRepository = RepositoryFactory.get('departments')
  const CustomerRepository = RepositoryFactory.get('customer')
  const RolesRepository = RepositoryFactory.get('roles');
  const FormulationsRepository = RepositoryFactory.get('formulations')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  const DropDownRepository = RepositoryFactory.get('drop_down')


  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      roles: [],
      selectedStaff: {},
      departments: [],
      selected: [],
      updateStaffSelected: [],
      project_briefs: [],
      createStaffForm: {
        batch_weight: '100'
      },
      sage_nominal_codes:[],
    }
  }

export default {
  name: 'CreateFormulationPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (pb_id) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        await this.getSageNominalCodes()
        this.fetchProjectBrief();
        if (pb_id) {
          this.createStaffForm.customer_project_brief_id = pb_id
        }
        // this.loadDepartments();
      } catch (error) {

      }
    },

    async onClickCreateFormulation () {
      const vue = this;
      this.$vs.loading()
       try {
         const { data } = (await FormulationsRepository.create(this.createStaffForm)).data
         this.showSuccessMessage('Formulation created successfully')
         this.createStaffForm = {}
        //  await vue.$parent.refreshData()
        this.open = false;
        this.$router.push({path: `/pages/formulations/${data.id}`})
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },

    async loadDepartments() {
      const {data} = await DepartmentsRepository.get(' ', '', '', '' )
      this.departments =  data.data
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },

    async loadRoles() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.50
      });
      this.roles = [];
      const {data} = await RolesRepository.get(' ', '', '', '' )
      this.roles =  data.data
      await this.$vs.loading.close('#popup > .con-vs-loading')
    },

    async getStaff(id) {
      const { data } = await StaffRepository.getStaff(id)
      this.selectedStaff = data.data
    },
    onClickReset() {
      this.createStaffForm = {}
      this.selected= []
    },
    async fetchProjectBrief() {
      this.$vs.loading()
      try {
        const {data} = await DropDownRepository.getProjectBriefDropDownList()
        this.project_briefs =  data.data
      } catch (e) {
        this.showErrorMessage('Something went wrong [project briefs]')
        this.open = false
      }
      this.$vs.loading.close()
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.create-formula-popup >>> .vs-popup {
  min-height: 60% !important;
  min-width: 40% !important;
}

</style>
